/* ======================================================
   Axeptio + Shopify + Google Consent Mode v2 + GTM
   Version PROD – RGPD compliant
   ====================================================== */

/* =========================
   Axeptio configuration
   ========================= */
window.axeptioSettings = {
  clientId: "61b2040d227b9f44c0869353",
  cookiesVersion: {
    type: "custom_function",
    config: {
      function: () => document.documentElement.lang
    },
    cases: {
      default: "-fr"
    }
  },
  userCookiesDomain: "morphee.co"
};

/* Load Axeptio SDK */
(function (d, s) {
  var t = d.getElementsByTagName(s)[0],
      e = d.createElement(s);
  e.async = true;
  e.src = "//static.axept.io/sdk.js";
  t.parentNode.insertBefore(e, t);
})(document, "script");


/* ======================================
   Google Consent Mode V2 – DEFAULT
   ====================================== */
window.dataLayer = window.dataLayer || [];
function gtag(){ dataLayer.push(arguments); }

gtag('consent', 'default', {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  wait_for_update: 500
});


/* =========================
   Shopify vendors mapping
   ========================= */
window.vendors_shopify = [
  {
    name: "shopify_preferences",
    title: "Préférences",
    shortDescription: "Cookies qui mémorisent vos préférences (langue, pays, etc.)",
    policyUrl: "https://www.shopify.com/legal/terms",
    domain: "shopify.com"
  },
  {
    name: "shopify_analytics",
    title: "Analytique",
    shortDescription: "Cookies pour mesurer l’audience et l’utilisation du site",
    policyUrl: "https://www.shopify.com/legal/terms",
    domain: "shopify.com"
  },
  {
    name: "shopify_marketing",
    title: "Marketing",
    shortDescription: "Cookies publicitaires et marketing",
    policyUrl: "https://www.shopify.com/legal/terms",
    domain: "shopify.com"
  },
  {
    name: "shopify_sale_of_data",
    title: "Vente de données",
    shortDescription: "Choix concernant le partage ou la vente de données",
    policyUrl: "https://www.shopify.com/legal/terms",
    domain: "shopify.com"
  }
];


/* =========================
   Axeptio callbacks
   ========================= */
window._axcb = window._axcb || [];
window._axcb.push(function (axeptio) {

  /* ---------- READY ---------- */
  axeptio.on("ready", function () {
    if (!axeptio.cookiesConfig) return;

    /* Inject Shopify step into Axeptio widget */
    axeptio.cookiesConfig.steps.splice(1, 0, {
      hasVendors: true,
      image: "cookie-bienvenue",
      layout: "category",
      name: "shopify",
      onlyOnce: true,
      title: "Cookies Shopify",
      subTitle: "Shopify utilise plusieurs services. Acceptez-vous leur usage ?",
      message: "Vous pouvez contrôler ces services via l’API de confidentialité Shopify.",
      vendors: window.vendors_shopify
    });

    /* Load Shopify Consent API safely */
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        { name: "consent-tracking-api", version: "0.1" }
      ]);
    }
  });


  /* ---------- CONSENT SAVED ---------- */
  axeptio.on("consent:saved", function (payload) {
    var vendors =
      payload &&
      payload.consent &&
      payload.consent.preferences &&
      payload.consent.preferences.vendors
        ? payload.consent.preferences.vendors
        : {};

    /* === Google Consent Mode update === */
    gtag('consent', 'update', {
      ad_storage: vendors.shopify_marketing ? 'granted' : 'denied',
      analytics_storage: vendors.shopify_analytics ? 'granted' : 'denied',
      ad_user_data: vendors.shopify_marketing ? 'granted' : 'denied',
      ad_personalization: vendors.shopify_marketing ? 'granted' : 'denied'
    });

    /* === Load GTM once analytics consent is granted === */
    if (vendors.shopify_analytics && !window.gtmLoaded) {
      window.gtmLoaded = true;

      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-TCSLCN6');
    }

    /* === Shopify Privacy API sync (safe) === */
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent({
        preferences: !!vendors.shopify_preferences,
        analytics: !!vendors.shopify_analytics,
        marketing: !!vendors.shopify_marketing,
        sale_of_data: !!vendors.shopify_sale_of_data
      }, function () {});
    }

    /* === Custom GTM event === */
    window.dataLayer.push({
      event: "axeptio_consent_saved",
      axeptio: {
        analytics: !!vendors.shopify_analytics,
        marketing: !!vendors.shopify_marketing
      }
    });
  });

});
